<popup-c class="bs-enabled" width="1200px"
	   head="Collaboration Rule Usage Data" size="large"
	   subTitle="<b>Rule name:</b> {{data.ruleObj.name}}"
	   (closeCb)="closeModal();">
	<div class="flex-column f-1-0 gap-4" style="overflow: auto;">
		<div class="flex-row gap-4 align-items-center">
			<!--period selection-->
			<div class="period-buttons-group flxRow hSpace1">
				<btn-c
					variant="{{usagePeriod.value !== periodObj.value ? 'outlined' : ''}}"
					*ngFor="let periodObj of trendsPeriod"
					[isDisabled]="getRuleUsageInProcess"
					(action)="changePeriod(periodObj);">
					{{periodObj.display}}
				</btn-c>
			</div>
			<div class="vertical-separator opacity-25"></div>
			<!--list/graph selection-->
			<div class="period-buttons-group align-self-center flex-row gap-2 animated fadeIn">
				<button class="period-button bs-btn bs-btn-light text-capitalize"
						*ngFor="let type of viewTypes | keyvalue: gs.returnZero;"
						[ngClass]="{'chosen' : type.value === viewType}"
						(click)="changeViewType(type.value);"
						tooltip="{{type.value}}">
					<i style="height: 20px; width: 20px; font-size: 1.1rem; margin-left: 2px;"
					   [ngClass]="type.value === viewTypes.list ? 'far fa-list' : 'fas fa-chart-pie'"></i>
				</button>
			</div>

			<div *ngIf="getRuleUsageInProcess" class="loading-spinner" style="width: 20px; height: 20px; border-width: 3px;"></div>

		</div>
		<div class="flex-column f-1-0 animated fadeIn" style="overflow: auto;" *ngIf="viewType === viewTypes.list">
			<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5; word-break: break-word;"
				[list]="assets"
				[headers]="[
					{text:'User', sortKey:'user'},
					{text:'Resource', sortKey:'resource_id.name'},
					{text:'Type', sortKey:'asset_type', width: '100px'},
					{text:'Created', sortKey:'created', width: '135px'},
				]"
				[cellsPrototype]="[
					{textKey: 'user'},
					{html: 'resourceCell'},
					{textKey: 'asset_type'},
					{textKey: 'created', textType: 'dateAndTime'},
				]"
				[cellActions]="{
					enable: true,
					selectItemActionCb: selectAssetAction,
					initActionsFunction: showAssetActions
				}"
				(searchFunction)="searchRuleAsset($event.searchTerm)"
				[options]="{
					exportToCsvFunction: exportRuleAssetsToCsv,
					defaultSortKey: '-created',
					isEllipsis: false,
					itemsNameSingular: 'asset',
				}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<div class="flex-column gap-1" *ngIf="cellId === 'resourceCell'">
						<span class="ellipsis">{{item.resource_id?.name || 'N/A'}}</span>
						<div class="flex-row gap-1 align-items-center">
							<span style="display: inline-flex; align-items: center; gap: 5px; padding: 2px 8px; border-radius: 20px; font-size: 11px; font-weight: 600; background: #f1f5f9; color: #475569; text-transform: capitalize;">
								<i class="far" style="font-size: 10px; color: #486db5;" [ngClass]="{
									'fa-hashtag': item.resource_id?.resource_type === 'channel',
									'fa-comments': item.resource_id?.resource_type === 'chat',
									'fa-video': item.resource_id?.resource_type === 'meeting',
									'fa-globe': item.resource_id?.resource_type === 'site',
									'fa-cloud': item.resource_id?.resource_type === 'OneDrive'
								}"></i>
								{{item.resource_id?.resource_type || 'N/A'}}
							</span>
						</div>
					</div>
				</ng-template>

				<div tableButtons>
					<span style="font-size: 0.95rem;">List of the assets caught by this rule in the {{usagePeriod.display | lowercase}}</span>
				</div>
			</trustifi-table-c>
		</div>

		<div class="flex-column f-1-0 position-relative animated fadeIn bg-light overflow-auto" *ngIf="viewType === viewTypes.chart">

			<div class="bs-container f-1-0 flex-column bg-light border overflow-auto">
				<div class="bs-row h-100 f-1-0 overflow-auto">
					<!--Assets Activity-->
					<div class="bs-col-6 p-2" style="min-height: 300px;">
						<div class="trends-data-card flex-column gap-1 p-3 w-100">
							<div class="flex-column align-items-start gap-1">
								<h6 class="m-0 fw-bold">Total amount of assets detected by this rule</h6>
							</div>
							<div class="flex-column centralize f-1-0 p-3">
								<apx-chart class="f-1-0 animated fadeIn align-self-stretch" style="z-index: 40;"
										   *ngIf="assets?.length"
										   #assetsActivityChart
										   [options]="{display: false}"
										   [series]="assetsActivityChartOptions.series"
										   [chart]="assetsActivityChartOptions.chart"
										   [plotOptions]="assetsActivityChartOptions.plotOptions"
										   [colors]="assetsActivityChartOptions.colors"
										   [dataLabels]="assetsActivityChartOptions.dataLabels"
										   [stroke]="assetsActivityChartOptions.stroke"
										   [yaxis]="assetsActivityChartOptions.yaxis"
										   [fill]="assetsActivityChartOptions.fill"
										   [tooltip]="assetsActivityChartOptions.tooltip"
										   [xaxis]="assetsActivityChartOptions.xaxis"></apx-chart>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!assets?.length">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getRuleUsageInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getRuleUsageInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--Most Involved Users-->
					<div class="bs-col-6 p-2" style="min-height: 300px;">
						<div class="trends-data-card flex-column gap-1 p-3 w-100 h-100">
							<div class="flex-column align-items-start gap-1">
								<h6 class="m-0 fw-bold">Top Matched Users</h6>
							</div>
							<div class="mt-2" *ngIf="involvedUsersList?.length">
								<div class="flxClmn gap-2" *ngIf="!getRuleUsageInProcess">
									<div class="flxRow-between align-items-center hvr-opacity"
										 style="padding: 6px 0; border-bottom: 1px solid #f1f5f9;"
										 *ngFor="let user of involvedUsersList; let i = index; let last = last"
										 [style.border-bottom]="last ? 'none' : '1px solid #f1f5f9'">
										<div class="flxRow gap-2 align-items-center">
											<span style="width: 20px; font-size: 12px; font-weight: 600; color: #94a3b8;">{{i + 1}}</span>
											<span style="font-size: 13px; color: #1e293b;">{{user.email}}</span>
										</div>
										<span style="font-size: 11px; font-weight: 600; padding: 2px 8px; border-radius: 999px; background: #f1f5f9; color: #64748b;">
											{{user.hits}} hit{{user.hits > 1 ? 's' : ''}}
										</span>
									</div>
								</div>
							</div>
							<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!involvedUsersList?.length">
								<div class="flex-column text-center centralize f-1-0">
									<span class="fw-500 opacity-75" *ngIf="!getRuleUsageInProcess">No data for selected time period</span>
									<loader class="opacity-75 align-self-center" *ngIf="getRuleUsageInProcess" height="100" width="100"></loader>
								</div>
							</div>
						</div>
					</div>

					<!--DLP Sensitivity Types-->
					<div class="bs-col-6 p-2" style="min-height: 300px;">
						<div class="trends-data-card flex-column gap-1 p-3 w-100 f-1-0">
							<div class="flex-column align-items-start gap-1">
								<h6 class="m-0 fw-bold">Results sorted by DLP Sensitivity Types</h6>
							</div>
							<div class="flex-column centralize f-1-0 p-3">
								<apx-chart class="pie-chart f-1-0 animated fadeIn align-self-stretch"
										   style="max-height: 215px;"
										   *ngIf="sensitivityTypesChartOptions?.labels?.length"
										   #sensitivityTypesChart
										   [series]="sensitivityTypesChartOptions.series"
										   [chart]="sensitivityTypesChartOptions.chart"
										   [dataLabels]="sensitivityTypesChartOptions.dataLabels"
										   [plotOptions]="sensitivityTypesChartOptions.plotOptions"
										   [colors]="sensitivityTypesChartOptions.colors"
										   [labels]="sensitivityTypesChartOptions.labels"></apx-chart>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!sensitivityTypesChartOptions?.labels?.length">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getRuleUsageInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getRuleUsageInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>
					</div>

						<!--Threat Types-->
					<div class="bs-col-6 p-2" style="min-height: 300px;">
						<div class="trends-data-card flex-column gap-1 p-3 w-100 f-1-0">
							<div class="flex-column align-items-start gap-1">
								<h6 class="m-0 fw-bold">Results sorted by threat types</h6>
							</div>
							<div class="flex-column centralize f-1-0 p-3">
								<apx-chart class="pie-chart f-1-0 animated fadeIn align-self-stretch"
										   style="max-height: 215px;"
										   *ngIf="threatTypesChartOptions?.labels?.length"
										   #threatTypesChart
										   [series]="threatTypesChartOptions.series"
										   [chart]="threatTypesChartOptions.chart"
										   [dataLabels]="threatTypesChartOptions.dataLabels"
										   [plotOptions]="threatTypesChartOptions.plotOptions"
										   [colors]="threatTypesChartOptions.colors"
										   [labels]="threatTypesChartOptions.labels"></apx-chart>
								<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!threatTypesChartOptions?.labels?.length">
									<div class="flex-column text-center centralize f-1-0">
										<span class="fw-500 opacity-75" *ngIf="!getRuleUsageInProcess">No data for selected time period</span>
										<loader class="opacity-75 align-self-center" *ngIf="getRuleUsageInProcess" height="100" width="100"></loader>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</popup-c>

<collaboration-asset-info
	*ngIf="currentAssetInfoObj"
	[asset]="currentAssetInfoObj"
	(closeCb)="currentAssetInfoObj = null;">
</collaboration-asset-info>
